'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const { Component } = React;
const ZoomPanModel = require('./ZoomPanModel');
const { noop } = require('global/mixins/commonjs/basicUtils');
const classnames = require('classnames');

/**
 * Handle both pinching and zooming on the passed in children.
 */
class PinchZoomComponent extends Component {
    constructor(props) {
        super(props);

        // Wire up touch detection.
        this._model = new ZoomPanModel({
            onZoomIn: this._onZoomIn.bind(this),
            onZoomOut: this._onZoomOut.bind(this),
            onPan: this._onPan.bind(this),
        });

        if (!props.enabled) {
            this._model.disable();
        }

        this.state = {
            transition: false,
        };
    }

    componentDidMount() {
        this._model.setEl(this.refs.wrapper);
    }

    componentWillReceiveProps(nextProps) {
        // Allow this component to be enabled/disabled via props.
        if (nextProps.enabled && !this.props.enabled) {
            this._model.enable();
            return;
        }

        if (!nextProps.enabled && this.props.enabled) {
            this._model.disable();
            return;
        }
    }

    componentWillUnmount() {
        this._model.destroy();
    }

    reset() {
        this._model.reset();
        this.forceUpdate();
    }

    /**
     * Set whether to use CSS transitions. Transition is meant to be set during zoom but not during pan.
     */
    _transition() {
        const el = this.refs.wrapper;
        let timer;
        let handler;
        const innerHandler = () => {
            this.setState({ transition: false });
            el.removeEventListener('transitionend', handler);
        };
        // Set a timeout in case the transitionend event fails for some reason. The timeout should be the same as the
        // CSS transition duration.
        timer = setTimeout(innerHandler, 300);
        handler = () => {
            innerHandler();
            clearTimeout(timer);
        };
        el.addEventListener('transitionend', handler);

        this.setState({ transition: true });
    }

    _onPan() {
        this.props.onPan();
        this.forceUpdate();
    }

    _onZoomIn() {
        this.props.onZoomIn();
        this._transition();
    }

    _onZoomOut() {
        this.props.onZoomOut();
        this._transition();
    }

    render() {
        const style = {};
        // Grab the styles from the model.
        this._model.getStyle(style);

        const className = classnames({
            transition: this.state.transition,
            [this.props.className]: this.props.className,
        });

        return (
            <div ref="wrapper" style={style} className={className}>
                {this.props.children}
            </div>
        );
    }
}

PinchZoomComponent.propTypes = {
    onZoomIn: PropTypes.func,
    onZoomOut: PropTypes.func,
    onPan: PropTypes.func,
    className: PropTypes.string,
    enabled: PropTypes.bool,
    children: PropTypes.node,
};

PinchZoomComponent.defaultProps = {
    onZoomIn: noop,
    onZoomOut: noop,
    onPan: noop,
    enabled: true,
};

module.exports = PinchZoomComponent;



// WEBPACK FOOTER //
// ./assets/js/global/components/PinchZoomComponent.jsx